import { Box } from "@mui/material";

export default function SharedPublicationCovers({ links, linksCover, dir }) {
  if (!links || !linksCover) return null;

  const keys = Object.keys(links).filter(
    (key) => links[key] && linksCover[key],
  );
  if (!keys.length) return null;

  return (
    <Box className="shared-message-links" dir={dir}>
      {keys.map((key) => (
        <button
          key={key}
          type="button"
          className="shared-link-card"
          onClick={() =>
            window.open(String(links[key]), "_blank", "noopener,noreferrer")
          }
          aria-label={String(links[key])}
        >
          <img
            src={String(linksCover[key])}
            alt=""
            crossOrigin="anonymous"
            onError={(e) => {
              const card = e.currentTarget.closest(".shared-link-card");
              if (card) card.style.display = "none";
            }}
          />
        </button>
      ))}
    </Box>
  );
}
